import React, { useState } from "react";
import {
  ContactUsAddress,
  ContactUsAddressContainer,
  ContactUsAddressDesc,
  ContactUsAddressImage,
  ContactUsAddressName,
  ContactUsContainer,
  ContactUsDesc,
  ContactUsHeaderSection,
  ContactUsLocationContainer,
  ContactUsLocationItem,
  ContactUsLocationTitle,
  ContactUsLocationWrapper,
  ContactUsTitle
} from "styles/pages/contact-us.styles";

import Image from "next/legacy/image";
import IndiaOffice from "public/assets/contact-us/india.png";
import IndonesiaOffice from "public/assets/contact-us/indonesia.png";
import SingaporeOffice from "public/assets/contact-us/singapore.png";
import UAEOffice from "public/assets/contact-us/uae.png";
import { HomeSEO } from "seo/home.seo";

enum OfficeLocations {
  Indonesia = "ID",
  India = "IN",
  Singapore = "SG",
  UAE = "UAE"
}

const OfficeLocationGoogleMapsLinks = {
  indonesia: "https://goo.gl/maps/PpVwXzXvXDRKpx8m7",
  india: "https://goo.gl/maps/48kNmPTeCEWdzFve6",
  singapore: "https://goo.gl/maps/BbxqGwCPTM7rH2mX6",
  uae: "https://goo.gl/maps/g7np62DyqJRd3vvT7"
};

const ContactUs: React.FC = () => {
  const [selectedLocation, setSelectedLocation] = useState(
    OfficeLocations.Indonesia
  );
  return (
    <ContactUsContainer>
      <HomeSEO />
      <ContactUsHeaderSection>
        <ContactUsTitle>Contact Us</ContactUsTitle>
        <ContactUsDesc>
          For inquiries, contact us at{" "}
          <a href="mailto:info@colearn.id">info@colearn.id</a>
        </ContactUsDesc>
      </ContactUsHeaderSection>
      <ContactUsLocationContainer>
        <ContactUsLocationTitle>Our Offices</ContactUsLocationTitle>
        <ContactUsLocationWrapper>
          <ContactUsLocationItem
            isSelected={selectedLocation === OfficeLocations.Indonesia}
            onClick={() => setSelectedLocation(OfficeLocations.Indonesia)}
          >
            Indonesia
          </ContactUsLocationItem>
          <ContactUsLocationItem
            isSelected={selectedLocation === OfficeLocations.India}
            onClick={() => setSelectedLocation(OfficeLocations.India)}
          >
            India
          </ContactUsLocationItem>
          <ContactUsLocationItem
            isSelected={selectedLocation === OfficeLocations.Singapore}
            onClick={() => setSelectedLocation(OfficeLocations.Singapore)}
          >
            Singapore
          </ContactUsLocationItem>
          <ContactUsLocationItem
            isSelected={selectedLocation === OfficeLocations.UAE}
            onClick={() => setSelectedLocation(OfficeLocations.UAE)}
          >
            UAE
          </ContactUsLocationItem>
        </ContactUsLocationWrapper>
        {selectedLocation === OfficeLocations.Indonesia && (
          <ContactUsAddressContainer>
            <ContactUsAddressName>PT IQ Edukasi</ContactUsAddressName>
            <ContactUsAddressDesc>Headquater</ContactUsAddressDesc>
            <ContactUsAddress>
              <p>GoWork Millenial Centenium Center Lt. 42</p>
              <p>Jl. Jend. Sudirman Kav. 25</p>
              <p>Jakarta Selatan, 12920</p>
            </ContactUsAddress>
            <ContactUsAddressImage
              onClick={() =>
                window.open(OfficeLocationGoogleMapsLinks.indonesia)
              }
            >
              <Image
                src={IndonesiaOffice}
                alt="Location to Indonesia Office of Coelearn"
              />
            </ContactUsAddressImage>
          </ContactUsAddressContainer>
        )}
        {selectedLocation === OfficeLocations.India && (
          <ContactUsAddressContainer>
            <ContactUsAddressName>
              Belajar Technologies Private Ltd.
            </ContactUsAddressName>
            <ContactUsAddress>
              <p>
                Hanto Workspace Technologies Pvt Ltd 2nd Floor, Hanto Kebarbiq,
              </p>
              <p>FFK Towers #445, 17th Cross Road, HSR Layout S.O,</p>
              <p>Bangalore South, Bangalore, Karnataka, India 560102</p>
            </ContactUsAddress>
            <ContactUsAddressImage
              onClick={() => window.open(OfficeLocationGoogleMapsLinks.india)}
            >
              <Image
                src={IndiaOffice}
                alt="Location to India Office of Colearn"
              />
            </ContactUsAddressImage>
          </ContactUsAddressContainer>
        )}
        {selectedLocation === OfficeLocations.Singapore && (
          <ContactUsAddressContainer>
            <ContactUsAddressName>IQ Edu Pte Ltd</ContactUsAddressName>
            <ContactUsAddress>
              <p> Phillip Street #14-05</p>
              <p>Royal Group Building</p>
              <p>Singapore, 048693</p>
            </ContactUsAddress>
            <ContactUsAddressImage
              onClick={() =>
                window.open(OfficeLocationGoogleMapsLinks.singapore)
              }
            >
              <Image
                src={SingaporeOffice}
                alt="Location to Singapore Office of Colearn"
              />
            </ContactUsAddressImage>
          </ContactUsAddressContainer>
        )}
        {selectedLocation === OfficeLocations.UAE && (
          <ContactUsAddressContainer>
            <ContactUsAddressName>
              IQ EDU - SOLE PROPRIETORSHIP LLC
            </ContactUsAddressName>
            <ContactUsAddress>
              <p> C/O Alpha Wave Incubator, Fl. 4</p>
              <p>
                Etihad Airways Center, Al Muneera District of Al Raha Beach,
              </p>
              <p>Abu Dhabi, UAE, 767338</p>
              <p>
                <strong>PO Box</strong> 0000
              </p>
            </ContactUsAddress>
            <ContactUsAddressImage
              onClick={() => window.open(OfficeLocationGoogleMapsLinks.uae)}
            >
              <Image src={UAEOffice} alt="Location to UAE Office of Colearn" />
            </ContactUsAddressImage>
          </ContactUsAddressContainer>
        )}
      </ContactUsLocationContainer>
    </ContactUsContainer>
  );
};

export default ContactUs;
